const INVOICE_STATUS_PILL_STYLE = {
  draft: { background: "#98BAF0", color: "#2146AA", border: "1px solid #027DDB" },
  sent: { background: "#E3D38D", color: "#6B581F", border: "1px solid #917E00" },
  paid: { background: "#B8FFA4", color: "#2F732E", border: "1px solid #2E9403" },
  "partial payment": { background: "#85CA85", color: "#047002", border: "1px solid #2E9403" },
  "partially-paid": { background: "#85CA85", color: "#047002", border: "1px solid #2E9403" },
  updated: { background: "#FDD9A0", color: "#854D0E", border: "1px solid #C2700F" },
  approved: { background: "#FDD9A0", color: "#854D0E", border: "1px solid #C2700F" },
  cancelled: { background: "#f94e35", color: "#fff", border: "1px solid #c82d17" },
  void: { background: "#f94e35", color: "#fff", border: "1px solid #c82d17" },
  overdue: { background: "#f94e35", color: "#fff", border: "1px solid #c82d17" },
};

export function getInvoiceStatusPillStyle(status) {
  const key = String(status || "").trim().toLowerCase();
  return INVOICE_STATUS_PILL_STYLE[key] || undefined;
}
